import { ForceList } from "slotworks/debug/menu/force-list";

export default abstract class DebugTab {
    protected name: string;
    protected resultList?: ForceList;

    constructor(name: string, resultList?: ForceList) {
        this.name = name;
        this.resultList = resultList;
    }

    public getName(): string {
        return this.name;
    }

    public abstract render(root: HTMLElement, hide: Function): void;

    public refresh(): void {
        // Do nothing.
    }

    protected addResultButton(root: HTMLElement, hide: Function, id: string) {
        const btn = document.createElement("button");

        btn.style.fontSize = "3vw";
        btn.style.margin = "1vmax 1vw";
        btn.style.borderRadius = "10px";
        btn.style.width = "35vw";
        btn.style.height = "10vmax";
        btn.style.backgroundColor = "#ffffff";
        btn.style.outline = "none";
        btn.style.cursor = "pointer";
        btn.innerText = id;

        btn.onclick = () => {
            this.resultList.force(id).execute();
            hide();
        };

        root.appendChild(btn);
    }

    protected addSeparator(root: HTMLElement) {
        root.appendChild(document.createElement("hr"));
    }
}
